import React from 'react';
import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';
import store from '../s';
import {checkout} from '../../api';
import * as util from '../../util';
import Message from './msg';
declare var openz: any;

@observer
export default class ConfidenceComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    // tslint:disable-next-line
    @computed get total() {
        let _total = store.checkout.cart.pricing.subtotal - store.checkout.cart.pricing.discount - store.checkout.cart.pricing.discount_shipping;
        _total = _total - store.checkout.cart.pricing.gift + store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production + store.checkout.cart.pricing.tax;
        return _total;
    }
    @computed get cartItemTotal() {
        return store.checkout.cart.items.map(o => o.qty).reduce((a, b) => a + b, 0);
    }

    @computed get showApplePay() {
        return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    @computed get EstPostalCode() {
        return (store.checkout.ship.addr.postalCode.value.trim() === '' ? store.checkout.ship.estimatedPostalCode : store.checkout.ship.addr.postalCode.value).trim();
    }

    @computed get showEstBox() {
        return store.checkout.cart.pricing.isEstShipping && store.checkout.cart.pricing.shipping < 1;
    }

    @action
    handleCheckoutTypeChange = async (e: ICheckoutType) => {
        store.checkout.CheckoutType = e;
        store.moveStep(ICheckoutStep.checkout);
    };

    render() {
        return (
            <div className="confidence">
                {!store.checkout.isMyFrames && (
                    <div className="conf-flex">
                        <div>
                            <i
                                className="fas fa-box-open"
                                aria-hidden={true}
                            />
                        </div>
                        <div>
                            <div className="form-label form-label-light">EASY RETURNS</div>
                            <div className="info">
                                We have your back with a{' '}
                                <span
                                    className="link pointer underline"
                                    style={{fontSize: 13}}
                                    tabIndex={0}
                                    onClick={() => util.modal('modal-return-policy')}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            util.modal('modal-return-policy');
                                        }
                                    }}
                                >
                                    {store.PortalID === 3 ? '30' : '120'}-day return policy
                                </span>
                            </div>
                        </div>
                    </div>
                )}
                <div className="conf-flex">
                    <div>
                        <i
                            className="fas fa-ruler-combined"
                            aria-hidden={true}
                        />
                    </div>
                    <div>
                        <div className="form-label form-label-light">Made special for you</div>
                        <div className="info">Each frame is handcrafted and custom-made</div>
                    </div>
                </div>
                <div
                    className="conf-flex"
                    style={{paddingBottom: 12}}
                >
                    <div>
                        <i
                            className="fas fa-award"
                            aria-hidden={true}
                        />
                    </div>
                    <div>
                        <div className="form-label form-label-light">USA-made Quality</div>
                        <div className="info">We pride ourselves on premium quality</div>
                    </div>
                </div>

                {store.checkout.isMyFrames && store.PortalID < 1 && (
                    <div
                        className="conf-flex"
                        style={{paddingBottom: 12}}
                    >
                        <div>
                            <i
                                className={store.PortalID !== 3 ? `fas fa-shipping-fast` : `fas fa-cart-shopping-fast`}
                                aria-hidden={true}
                            />
                        </div>
                        <div>
                            <div className="form-label form-label-light">Shipping Information</div>
                            <div className="info">
                                <a href="https://www.diplomaframe.com/customer-service/shipping-information.aspx">Shipping Options &amp; Rates</a>
                            </div>
                            <div className="info">
                                <a href="https://www.diplomaframe.com/customer-service/shipping-information.aspx">International Shipments</a>
                            </div>
                        </div>
                    </div>
                )}

                <div className="hr d-none d-sm-block" />
                <div
                    className="text-center d-none d-sm-block"
                    style={{paddingTop: 8}}
                >
                    <span className="chat-desktop d-none d-sm-block">
                        {store.Portal.CustomerServicePhone && (
                            <a
                                href={util.getPhoneHREF()}
                                style={{color: '#595959'}}
                            >
                                {store.Portal.CustomerServicePhone}
                            </a>
                        )}
                        {store.PortalID < 1 && (
                            <span style={{paddingLeft: 24, paddingRight: 4}}>
                                <span style={{paddingRight: 4, color: '#999', fontSize: '14px'}}>
                                    <i
                                        className="fas fa-comment-alt-dots"
                                        aria-hidden={true}
                                    />
                                </span>
                                <button
                                    style={{color: '#595959', fontSize: '14px'}}
                                    onClick={() => {
                                        openz();
                                        return false;
                                    }}
                                    className="text-btn"
                                    type="button"
                                    aria-label="Chat with customer service"
                                    aria-haspopup="dialog"
                                >
                                    Chat
                                </button>
                            </span>
                        )}
                    </span>
                </div>
            </div>
        );
    }
}
